// 120% y values so that hanging letters aren't cut off, e.g. lower-case q, y, p, g, j
export const RevealAnimationVariants = {
  clipPath: {
    property: "clipPath",
    cssProperty: "clip-path",
    variant: {
      start: "polygon(0 0, 120% 0, 120% 0, 0 0)",
      visible: "polygon(0 0, 120% 0, 120% 120%, 0% 120%)",
      hidden: "polygon(0 120%, 120% 120%, 100% 120%, 0% 120%)",
    },
  },
  clipPathReveal: {
    property: "clipPath",
    cssProperty: "clip-path",
    variant: {
      start: "polygon(0 0, 0 0, 0 120%, 0% 120%)",
      visible: "polygon(0 0, 120% 0, 120% 120%, 0% 120%)",
      hidden: "polygon(120% 0, 120% 0, 120% 120%, 120% 120%)",
    },
  },
  translateY: {
    property: "y",
    cssProperty: "transform",
    variant: {
      start: "120%",
      visible: "0%",
      hidden: "-120%",
    },
  },
};
